












import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import RegisterLogin from '@/renderer/views/register/index.vue';
import BaseLogin from './base.vue';
import Oauth2 from './oauth2.vue';
import PrivateLogin from './privateLogin.vue';
import SSOLogin from './ssoLogin.vue';

export default defineComponent({
  components: {
    BaseLogin,
    Oauth2,
    RegisterLogin,
    PrivateLogin,
    SSOLogin,
  },
  setup(props, context) {
    const vm = context.root;
    const isOauth2 = computed(() => vm.$route.query.oauth2 === '1' || vm.$route.name === 'oauth2');
    const isRegister = computed(() => vm.$route.name === 'register');
    const isSSO = computed(() => vm.$route.name === 'sso');

    return {
      isOauth2,
      isRegister,
      isSSO,
    };
  },
});
